module.exports = __webpack_public_path__ + "img/cover-yourself.8923bba5.svg";